{
  "alert": "경고",
  "dismiss": "무시"
}
